import defineCustomElement from '../../define-custom-element.js';

import TpButtonContainedSmall from './tp-button-contained-small.js';
import TpButtonContainedLarge from './tp-button-contained-large.js';
import TpButtonTextSmall from './tp-button-text-small.js';
import TpButtonTextLarge from './tp-button-text-large.js';
import TpButtonOutlinedSmall from './tp-button-outlined-small.js';
import TpButtonOutlinedLarge from './tp-button-outlined-large.js';
import TpButtonOutlinedLightSmall from './tp-button-outlined-light-small.js';
import TpButtonOutlinedLightLarge from './tp-button-outlined-light-large.js';
import TpButtonCtaSmall from './tp-button-cta-small.js';
import TpButtonCtaLarge from './tp-button-cta-large.js';


defineCustomElement('tp-button-contained-small', TpButtonContainedSmall);
defineCustomElement('tp-button-contained-large', TpButtonContainedLarge);

defineCustomElement('tp-button-text-small', TpButtonTextSmall);
defineCustomElement('tp-button-text-large', TpButtonTextLarge);

defineCustomElement('tp-button-outlined-small', TpButtonOutlinedSmall);
defineCustomElement('tp-button-outlined-large', TpButtonOutlinedLarge);

defineCustomElement('tp-button-outlined-light-small', TpButtonOutlinedLightSmall);
defineCustomElement('tp-button-outlined-light-large', TpButtonOutlinedLightLarge);

defineCustomElement('tp-button-cta-small', TpButtonCtaSmall);
defineCustomElement('tp-button-cta-large', TpButtonCtaLarge);

export {
  TpButtonContainedSmall,
  TpButtonContainedLarge,
  TpButtonTextSmall,
  TpButtonTextLarge,
  TpButtonOutlinedSmall,
  TpButtonOutlinedLarge,
  TpButtonOutlinedLightSmall,
  TpButtonOutlinedLightLarge,
  TpButtonCtaSmall,
  TpButtonCtaLarge
}
